import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';
import { useBtcSpotPrices } from '../api/signals';

const usdFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/// Live BTC price chip rendered in the top-right of the shell header.
/// Sourced from Binance via the cross-exchange `/api/btc-spot-prices`
/// endpoint — react-query dedupes the fetch with the dedicated panel, so a
/// user sitting on `/signals/btc-spot-prices` doesn't pay twice. Clicking
/// jumps to that panel.
export default function BtcHeaderTicker() {
  const { data, isError } = useBtcSpotPrices();
  const navigate = useNavigate();

  const binance = data?.tickers.find((t) => t.exchange === 'binance');
  const price = binance?.ok ? (binance.price ?? null) : null;

  return (
    <Tooltip
      title={
        isError
          ? '读取失败，请确认 signals 服务已启动'
          : price === null
            ? '正在获取价格…'
            : 'Binance · BTCUSDT · 点击查看跨所对比'
      }
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => navigate('/signals/btc-spot-prices')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            navigate('/signals/btc-spot-prices');
          }
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 8px',
          cursor: 'pointer',
          userSelect: 'none',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: price === null ? '#999' : '#f5a623',
            // gentle pulse when live, static when stale.
            animation: price === null ? 'none' : 'btc-pulse 1.6s ease-in-out infinite',
          }}
        />
        <span style={{ fontWeight: 500, fontSize: 13 }}>BTC</span>
        <span style={{ fontSize: 13, color: '#000' }}>
          {price === null ? '—' : `$${usdFormatter.format(price)}`}
        </span>
      </div>
    </Tooltip>
  );
}
